import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Divider, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker
} from '@material-ui/pickers';

const theme = createMuiTheme({
    overrides: {
        /*MuiInputBase: {
            root: {
                marginTop: '20px',
            },
            input: {
                paddingTop: '10px',
            }
        },
        MuiFormLabel: {
            root: {
                width: '170px',
            },
        },    */
        MuiFormControl: {
            root: {
                marginTop: '16px',
                marginBottom: '8px',
            }
        }
    }
});

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    pos: {
        marginBottom: 12,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
    divider: {
        margin: 16,
    }
});

class ClaimENStep4 extends React.Component {
    state = {
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
    };

    componentDidMount() {
        if (!this.state.fp17data.cdsTTime) {
            let datatmp = this.state.fp17data;
            datatmp['cdsTTime'] = null;
            this.setState({ fp17data: datatmp });
        }

        //console.log('step 4');
        console.log(this.state);
    }

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;

        if (name === 'cds9611' && !datatmp.cdsTTime) {
            datatmp['cdsTTime'] = moment();
        }

        this.setState({ fp17data: datatmp });
    };

    handleChangeTime = name => date => {
        let datatmp = this.state.fp17data;
        datatmp[name] = date
        this.setState({ fp17data: datatmp });
    }

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true)
            value = event.target.value;
        else
            value = undefined;

        let datatmp = this.state.fp17data;
        datatmp[name] = value;
        this.setState({ fp17data: datatmp });
    };

    render() {
        const { classes } = this.props;

        return (
            <MuiThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div className={classes.root}>
                        <Paper className={classes.paper}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Part 5a Clinical Data Set
                            </Typography>
                            {(parseInt(this.state.fp17data.claim_band) >= 1 && parseInt(this.state.fp17data.claim_band) <= 4)
                                || (parseInt(this.state.fp17data.claim_band) >= 31 && parseInt(this.state.fp17data.claim_band) <= 32) ?
                                <Paper className={classes.paper}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Band 1 Items
                                    </Typography>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9317"
                                                    control={<Checkbox checked={this.state.fp17data.cds9317 === 'y'} />}
                                                    label="Examination"
                                                    onChange={this.handleCheckChange('cds9317')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9301"
                                                    label="Scale & Polish"
                                                    control={<Checkbox checked={this.state.fp17data.cds9301 === 'y'} />}
                                                    onChange={this.handleCheckChange('cds9301')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9302"
                                                    label="Flouride Varnish"
                                                    control={<Checkbox checked={this.state.fp17data.cds9302 === 'y'} />}
                                                    onChange={this.handleCheckChange('cds9302')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9303"
                                                label="Fissure sealants"
                                                value={this.state.fp17data.cds9303}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9303')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9304"
                                                label="Radiographs Taken"
                                                value={this.state.fp17data.cds9304}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="Enter no."
                                                onChange={this.handleChange('cds9304')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9316"
                                                label="Referral for AMS"
                                                value={this.state.fp17data.cds9316}
                                                type="number"
                                                inputProps={{ min: "1", max: "3", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="Enter band"
                                                onChange={this.handleChange('cds9316')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9318"
                                                label="Antibiotic items prescribed"
                                                value={this.state.fp17data.cds9318}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of items"
                                                onChange={this.handleChange('cds9318')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9399"
                                                    control={<Checkbox checked={this.state.fp17data.cds9399 === 'y'} />}
                                                    label="Other treatment"
                                                    onChange={this.handleCheckChange('cds9399')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9173"
                                                    control={<Checkbox checked={this.state.fp17data.cds9173 === 'y'} />}
                                                    label="Best practice prevention according to Delivering Better Oral Health offered"
                                                    onChange={this.handleCheckChange('cds9173')}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                : null}
                            {(parseInt(this.state.fp17data.claim_band) >= 3 && parseInt(this.state.fp17data.claim_band) <= 4)
                                || (parseInt(this.state.fp17data.claim_band) >= 31 && parseInt(this.state.fp17data.claim_band) <= 32) ?
                                <Paper className={classes.paper}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Band 2 Items
                                    </Typography>
                                    {parseInt(this.state.fp17data.claim_band) === 32 &&
                                    <div style={{fontWeight: 'bold', fontStyle: 'italic'}}>Band 2c - Molar Endodontics required for 7 UDAs</div>}
                                    {parseInt(this.state.fp17data.claim_band) === 31 &&
                                    <div style={{fontWeight: 'bold', fontStyle: 'italic'}}>Band 2b - Non-Molar Endodontics required for 5 UDAs</div>}
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9339"
                                                label="Advanced Perio Root Surface Debridement"
                                                value={this.state.fp17data.cds9339}
                                                type="number"
                                                inputProps={{ min: "0", max: "6", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of sextants"
                                                onChange={this.handleChange('cds9339')}
                                            />
                                        </Grid>
                                        {(this.state.fp17data.datacc > '2022-10-01') ?
                                        <>
                                            {parseInt(this.state.fp17data.claim_band) === 32 &&
                                            <Grid item xs={6} sm={4} md={2}>
                                                <TextField
                                                    id="cds9370"
                                                    label="Molar Endodontics"
                                                    value={this.state.fp17data.cds9370}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="No. of teeth"
                                                    onChange={this.handleChange('cds9370')}
                                                />
                                            </Grid> 
                                            }
                                            {parseInt(this.state.fp17data.claim_band) >= 31 &&
                                            <Grid item xs={6} sm={4} md={2}>
                                                <TextField
                                                    id="cds9371"
                                                    label="Non-Molar Endodontics"
                                                    value={this.state.fp17data.cds9371}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="No. of teeth"
                                                    onChange={this.handleChange('cds9371')}
                                                />
                                            </Grid> 
                                            }
                                            </> :
                                            <Grid item xs={6} sm={4} md={2}>
                                                <TextField
                                                    id="cds9305"
                                                    label="Endodontic treatment"
                                                    value={this.state.fp17data.cds9305}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="No. of teeth"
                                                    onChange={this.handleChange('cds9305')}
                                                />
                                            </Grid>
                                        }
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9306"
                                                label="Permanent fillings & Sealant restorations"
                                                value={this.state.fp17data.cds9306}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9306')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9307"
                                                label="Extractions"
                                                value={this.state.fp17data.cds9307}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9307')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9353"
                                                    label="Denture Additions/Reline/Rebase"
                                                    control={<Checkbox checked={this.state.fp17data.cds9353 === 'y'} />}
                                                    onChange={this.handleCheckChange('cds9353')}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                : null}
                            {(parseInt(this.state.fp17data.claim_band) === 4) ?
                                <Paper className={classes.paper}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Band 3 Items
                                    </Typography>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9308"
                                                label="Crown(s) provided"
                                                value={this.state.fp17data.cds9308}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9308')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9338"
                                                label="Preformed Crowns"
                                                value={this.state.fp17data.cds9338}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9338')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9309"
                                                label="Upper denture - Acrylic"
                                                value={this.state.fp17data.cds9309}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                onChange={this.handleChange('cds9309')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9310"
                                                label="Lower denture - Acrylic"
                                                value={this.state.fp17data.cds9310}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9310')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9311"
                                                label="Upper denture - Metal"
                                                value={this.state.fp17data.cds9311}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9311')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9312"
                                                label="Lower denture - Metal"
                                                value={this.state.fp17data.cds9312}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9312')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9313"
                                                label="Veneer(s) applied"
                                                value={this.state.fp17data.cds9313}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9313')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9314"
                                                label="Inlay(s)"
                                                value={this.state.fp17data.cds9314}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9314')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <TextField
                                                id="cds9315"
                                                label="Bridge(s) fitted"
                                                value={this.state.fp17data.cds9315}
                                                type="number"
                                                inputProps={{ min: "0", max: "32", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of teeth"
                                                onChange={this.handleChange('cds9315')}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9376"
                                                    label="Custom Made Occlusal Appliance - Hard Bite"
                                                    control={<Checkbox checked={this.state.fp17data.cds9376 === 'y'} />}
                                                    onChange={this.handleCheckChange('cds9376')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9377"
                                                    label="Custom Made Occlusal Appliance - Soft Bite"
                                                    control={<Checkbox checked={this.state.fp17data.cds9377 === 'y'} />}
                                                    onChange={this.handleCheckChange('cds9377')}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                : null}


                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl className={classes.formControl} fullWidth={true}>
                                        <FormLabel htmlFor="cds9181">Commissioning Flag</FormLabel>
                                        <Select
                                            value={this.state.fp17data.cds9181}
                                            onChange={this.handleChange('cds9181')}
                                            inputProps={{
                                                name: 'cds9181',
                                                id: 'cds9181'
                                            }}
                                        >
                                            <MenuItem value="01">Securing Access to Urgent Care</MenuItem>
                                            <MenuItem value="02">Promoting Access to Routine Care</MenuItem>
                                            <MenuItem value="03">Proving Care of High Needs Groups</MenuItem>
                                            <MenuItem value="04">Starting Well</MenuItem>
                                            <MenuItem value="05">Enhanced Health in Care Homes</MenuItem>
                                            <MenuItem value="06">Collaboration in Local Care Networks</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} sm={4} md={2}>
                                    <FormControl className={classes.formControl} fullWidth={true}>
                                        <FormControlLabel
                                            value="y"
                                            id="cds9375"
                                            control={<Checkbox checked={this.state.fp17data.cds9375 === 'y'} />}
                                            label="Phased Treatment"
                                            onChange={this.handleCheckChange('cds9375')}
                                        />
                                    </FormControl>
                                </Grid>

                                {/*parseInt(this.state.fp17data.claim_band) <= 4 ?
                                    <Grid item xs={4} md={3}>
                                        <Paper className={classes.paper}>
                                            <TextField
                                                id="cds9340"
                                                label="AGP Count"
                                                value={this.state.fp17data.cds9340}
                                                type="number"
                                                inputProps={{ min: "0", max: "20", step: "1" }}
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                margin="normal"
                                                fullWidth="true"
                                                helperText="No. of appointments"
                                                onChange={this.handleChange('cds9340')}
                                            />
                                        </Paper>
                                            </Grid> : null*/}

                                {parseInt(this.state.fp17data.claim_band) !== 13 ?
                                    <Grid item xs={12}>

                                        <Paper className={classes.paper}>
                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                Treatment triage data
                                            </Typography>
                                            <div>Enter the number of times you triaged a patient and they were within each of the following groups...</div>
                                            <div><b>This information is mandatory on all claims</b></div>
                                            <Grid container spacing={1}>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="cds9615"
                                                        label="Shielding"
                                                        value={this.state.fp17data.cds9615}
                                                        type="number"
                                                        inputProps={{ min: "1", max: "99", step: "1" }}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        margin="normal"
                                                        fullWidth="true"
                                                        onChange={this.handleChange('cds9615')}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="cds9616"
                                                        label="At risk"
                                                        value={this.state.fp17data.cds9616}
                                                        type="number"
                                                        inputProps={{ min: "1", max: "99", step: "1" }}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        margin="normal"
                                                        fullWidth="true"
                                                        onChange={this.handleChange('cds9616')}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="cds9617"
                                                        label="Possible COVID-19"
                                                        value={this.state.fp17data.cds9617}
                                                        type="number"
                                                        inputProps={{ min: "1", max: "99", step: "1" }}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        margin="normal"
                                                        fullWidth="true"
                                                        onChange={this.handleChange('cds9617')}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="cds9618"
                                                        label="Symptom free"
                                                        value={this.state.fp17data.cds9618}
                                                        type="number"
                                                        inputProps={{ min: "1", max: "99", step: "1" }}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        margin="normal"
                                                        fullWidth="true"
                                                        onChange={this.handleChange('cds9618')}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="cds9619"
                                                        label="Other status"
                                                        value={this.state.fp17data.cds9619}
                                                        type="number"
                                                        inputProps={{ min: "1", max: "99", step: "1" }}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        margin="normal"
                                                        fullWidth="true"
                                                        onChange={this.handleChange('cds9619')}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>

                                                </Grid>
                                            </Grid>
                                        </Paper>

                                    </Grid>
                                    : null}
                            </Grid>
                            {parseInt(this.state.fp17data.claim_band) !== 13 ?
                                <>
                                    <Divider variant="middle" className={classes.divider} />
                                    <Grid container spacing={1}>
                                        <Grid item xs={4} md={2}>
                                            {this.state.fp17data.years > 5 ?
                                                <TextField
                                                    id="cds9320"
                                                    label="Decayed teeth"
                                                    value={this.state.fp17data.cds9320}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="permanent"
                                                    onChange={this.handleChange('cds9320')}
                                                /> : null}
                                            {this.state.fp17data.years < 12 ?
                                                <TextField
                                                    id="cds9323"
                                                    value={this.state.fp17data.cds9323}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="deciduous"
                                                    onChange={this.handleChange('cds9323')}
                                                /> : null}
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            {this.state.fp17data.years > 5 ?
                                                <TextField
                                                    id="cds9321"
                                                    label="Missing teeth"
                                                    value={this.state.fp17data.cds9321}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="permanent"
                                                    onChange={this.handleChange('cds9321')}
                                                /> : null}
                                            {this.state.fp17data.years < 12 ?
                                                <TextField
                                                    id="cds9324"
                                                    value={this.state.fp17data.cds9324}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="deciduous"
                                                    onChange={this.handleChange('cds9324')}
                                                /> : null}
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            {this.state.fp17data.years > 5 ?
                                                <TextField
                                                    id="cds9322"
                                                    label="Filled teeth"
                                                    value={this.state.fp17data.cds9322}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="permanent"
                                                    onChange={this.handleChange('cds9322')}
                                                /> : null}
                                            {this.state.fp17data.years < 12 ?
                                                <TextField
                                                    id="cds9325"
                                                    value={this.state.fp17data.cds9325}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    helperText="deciduous"
                                                    onChange={this.handleChange('cds9325')}
                                                /> : null}
                                        </Grid>
                                        {this.state.fp17data.datacc > '2022-10-01' ?
                                            <Grid item xs={4} md={2}>
                                                <TextField
                                                    id="cds9379"
                                                    label="Untreated decayed teeth"
                                                    value={this.state.fp17data.cds9379}
                                                    type="number"
                                                    inputProps={{ min: "0", max: "32", step: "1" }}
                                                    className={classes.textField}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    margin="normal"
                                                    fullWidth="true"
                                                    onChange={this.handleChange('cds9379')}
                                                />
                                            </Grid>
                                            : null}

                                    </Grid>
                                </>
                                :
                                <>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9600"
                                                    control={<Checkbox checked={this.state.fp17data.cds9600 === 'y'} />}
                                                    label="Triage by DCP"
                                                    onChange={this.handleCheckChange('cds9600')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={false}>
                                                <KeyboardTimePicker
                                                    shrink required
                                                    margin="normal"
                                                    id="claim-ttime"
                                                    label="Time call ended"
                                                    className={classes.textField}
                                                    value={this.state.fp17data.cdsTTime}
                                                    onChange={this.handleChangeTime('cdsTTime')}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change time',
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9601"
                                                    control={<Checkbox checked={this.state.fp17data.cds9601 === 'y'} />}
                                                    label="Triage by video"
                                                    onChange={this.handleCheckChange('cds9601')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9602"
                                                    control={<Checkbox checked={this.state.fp17data.cds9602 === 'y'} />}
                                                    label="Advice given"
                                                    onChange={this.handleCheckChange('cds9602')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9603"
                                                    control={<Checkbox checked={this.state.fp17data.cds9603 === 'y'} />}
                                                    label="Advised appropriate analgesics"
                                                    onChange={this.handleCheckChange('cds9603')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9604"
                                                    control={<Checkbox checked={this.state.fp17data.cds9604 === 'y'} />}
                                                    label="Remote prescription issued for analgesics"
                                                    onChange={this.handleCheckChange('cds9604')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9605"
                                                    control={<Checkbox checked={this.state.fp17data.cds9605 === 'y'} />}
                                                    label="Remote prescription issued for antibiotics"
                                                    onChange={this.handleCheckChange('cds9605')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9606"
                                                    control={<Checkbox checked={this.state.fp17data.cds9606 === 'y'} />}
                                                    label="Follow-up call required"
                                                    onChange={this.handleCheckChange('cds9606')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9607"
                                                    control={<Checkbox checked={this.state.fp17data.cds9607 === 'y'} />}
                                                    label="Patient advised to call back if symptoms worsen"
                                                    onChange={this.handleCheckChange('cds9607')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    id="cds9614"
                                                    control={<Checkbox checked={this.state.fp17data.cds9614 === 'y'} />}
                                                    label="Face to Face appointment made but patient FTA'd"
                                                    onChange={this.handleCheckChange('cds9614')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel shrink id="select-cds96019">Referred to Local UDC</InputLabel>
                                                <Select
                                                    labelId="select-cds9609" value={this.state.fp17data.cds9609}
                                                    onChange={this.handleChange('cds9609')}
                                                    inputProps={{
                                                        name: 'cds9609',
                                                        id: 'claim-cds9609',
                                                    }}
                                                >
                                                    <MenuItem value="">---</MenuItem>
                                                    <MenuItem value="1">Life threatening</MenuItem>
                                                    <MenuItem value="2">Trauma</MenuItem>
                                                    <MenuItem value="3">Oro-facial swelling</MenuItem>
                                                    <MenuItem value="4">Post extraction bleeding</MenuItem>
                                                    <MenuItem value="5">Condition resulting in systematic illness</MenuItem>
                                                    <MenuItem value="6">Severe dental or facial pain</MenuItem>
                                                    <MenuItem value="7">Fractured teeth with pulp exposure</MenuItem>
                                                    <MenuItem value="8">Infection</MenuItem>
                                                    <MenuItem value="9">Suspected oral cancer</MenuItem>
                                                    <MenuItem value="10">Oro-dental conditions worsening</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel shrink id="select-cds9610">Patient Group</InputLabel>
                                                <Select
                                                    labelId="select-cds9610"
                                                    value={this.state.fp17data.cds9610}
                                                    onChange={this.handleChange('cds9610')}
                                                    inputProps={{
                                                        name: 'cds9610',
                                                        id: 'claim-cds9610',
                                                    }}
                                                >
                                                    <MenuItem value="">---</MenuItem>
                                                    <MenuItem value="1">Shielding</MenuItem>
                                                    <MenuItem value="2">At risk</MenuItem>
                                                    <MenuItem value="3">Possible COVID-19</MenuItem>
                                                    <MenuItem value="4">Symptom free</MenuItem>
                                                    <MenuItem value="5">Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel shrink id="select-cds9610">Primary reason for call</InputLabel>
                                                <Select
                                                    labelId="select-cds9611"
                                                    value={this.state.fp17data.cds9611}
                                                    onChange={this.handleChange('cds9611')}
                                                    inputProps={{
                                                        name: 'cds9611',
                                                        id: 'claim-cds9611',
                                                    }}
                                                >
                                                    <MenuItem value="">---</MenuItem>
                                                    <MenuItem value="1">Pain</MenuItem>
                                                    <MenuItem value="2">Swelling</MenuItem>
                                                    <MenuItem value="3">Bleeding</MenuItem>
                                                    <MenuItem value="4">Trauma</MenuItem>
                                                    <MenuItem value="5">Soft tissue pathology</MenuItem>
                                                    <MenuItem value="6">Other</MenuItem>
                                                    <MenuItem value="7">Routine treatment</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>}
                        </Paper>
                        {parseInt(this.state.fp17data.claim_band) !== 13 ?
                            <>
                                <Paper className={classes.paper}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Part 6 Other Services
                                    </Typography>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    label="Treatment on referral"
                                                    control={<Checkbox checked={this.state.fp17data.trtrfl === 'y'} />}
                                                    onChange={this.handleCheckChange('trtrfl')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    label="Free replacement/ repair"
                                                    control={<Checkbox checked={this.state.fp17data.os9153 === 'y'} />}
                                                    onChange={this.handleCheckChange('os9153')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={3}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    label="Further treatment within 2 months"
                                                    control={<Checkbox checked={this.state.fp17data.os9163 === 'y'} />}
                                                    onChange={this.handleCheckChange('os9163')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    label="Domiciliary services"
                                                    control={<Checkbox checked={this.state.fp17data.os9152 === 'y'} />}
                                                    onChange={this.handleCheckChange('os9152')}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={2}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <FormControlLabel
                                                    value="y"
                                                    label="Sedation services"
                                                    control={<Checkbox checked={this.state.fp17data.os9166 === 'y'} />}
                                                    onChange={this.handleCheckChange('os9166')}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </>
                            : null}
                    </div>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }
}

ClaimENStep4.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClaimENStep4);